module.exports = require('./timing').default
